import { render, staticRenderFns } from "./calendario.vue?vue&type=template&id=1aca855c&"
import script from "./calendario.vue?vue&type=script&lang=js&"
export * from "./calendario.vue?vue&type=script&lang=js&"
import style0 from "./calendario.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports